import { createRootRouteWithContext } from '@tanstack/react-router';
import { MainLayout } from '../feature/main-layout/main-layout';

export const Route = createRootRouteWithContext()({
    component: MainLayout,
});
